import { useEffect } from 'react'
import { Environment } from 'types/masterData'
import { env } from 'utils/envManager'

const CHANNEL = 'live-preview'
const CS_INIT_MESSAGE_TYPE = 'init'
const CS_URL = 'https://eu-app.contentstack.com'

export function useInitLivePreview() {
	useEffect(() => {
		if (
			env.NEXT_PUBLIC_ENV === Environment.Pro ||
			typeof window === 'undefined' ||
			window === window.parent // If it's true, it's not in an Iframe and we return
		) {
			return
		}

		window.parent.postMessage(
			{
				eventManager: 'contentstack-adv-post-message',
				metadata: {
					hash: `init-${crypto.randomUUID().split('-')[0]}`,
					nature: 'REQUEST',
				},
				channel: CHANNEL,
				type: CS_INIT_MESSAGE_TYPE,
				payload: {
					config: {
						shouldReload: false,
						href: window.location.href,
						mode: 'preview',
					},
				},
			},
			CS_URL
		)
	}, [])
}
